export enum RouterPath {
  root = '/',
  login = '/login',
  oauthRedirect = '/oauth/callback/:provider',
  signupComplete = '/signup/complete',
  forgotPassword = '/forgot-password',
  setNewPassword = '/forgot-password/set-new-password',
  devices = '/devices',
  deviceDetails = '/devices/:deviceId',
  deviceClaim = '/devices/claim',
  cameras = '/cameras',
  aiBridge = '/ai-bridge',
  deployments = '/deployments',
  apps = '/apps',
  datasets = '/datasets',
  datasetDetails = '/datasets/:datasetId',
  appDetails = '/apps/:appId',
  workspace = '/workspace',
  workspaceAcceptInvite = '/workspace-accept-invite',
  createWorkspace = '/workspaces/create',
  inviteMembers = '/workspaces/invite-members',
  subscription = '/subscription',
  vlm = '/vlm',
  tower = '/tower',
  crossCamera = '/cross-camera',
  changePassword = '/change-password'
}

export enum VlmNestedPath {
  pipelines = 'pipelines',
  hardware = 'hardware',
  results = 'results'
}

export enum CrossCameraNestedPath {
  installation = 'installation',
  pipelines = 'pipelines',
  people = 'people'
}

export enum TowerNestedPath {
  hardware = 'hardware',
  logs = 'logs'
}

export enum ApplicationNestedPath {
  models = 'models',
  modelDetails = 'models/:modelId',
  events = 'events'
}

export enum ModelNestedPath {
  selectBaseModel = 'select-base-model',
  training = 'training',
  selectDataset = 'select-dataset',
  labelData = 'label-data'
}

export enum CameraNestedPath {
  details = ':cameraId'
}

export enum AiBridgeNestedPath {
  details = ':bridgeId'
}

export enum WorkspaceNestedPath {
  members = 'members',
  settings = 'settings',
  apiKeys = 'api-keys',
  notifications = 'notifications'
}

export enum DeploymentNestedPath {
  create = ':appId/create'
}

export const buildAppLink = (appId: string, path: ApplicationNestedPath) => {
  const appLink = replacePathParams(RouterPath.appDetails, { appId })
  return `${appLink}/${path}`
}

export const buildModelLink = (appId: string, modelId: string) => {
  const modelLink = buildAppLink(appId, ApplicationNestedPath.modelDetails)
  return replacePathParams(modelLink, { modelId })
}

export const buildModelDetailsLink = (
  appId: string,
  modelId: string,
  path: ModelNestedPath
) => {
  const modelLink = buildModelLink(appId, modelId)
  return `${modelLink}/${path}`
}

export const buildCreateDeploymentLink = (appId: string) => {
  const createDeploymentLink = replacePathParams(DeploymentNestedPath.create, {
    appId
  })
  return `${RouterPath.deployments}/${createDeploymentLink}`
}

export const replacePathParams = (
  path: string,
  params: Record<string, string>
) => {
  let newPath = path

  Object.keys(params).forEach((key) => {
    newPath = newPath.replace(`:${key}`, params[key])
  })

  return newPath
}
